import { render, staticRenderFns } from "./ANxAVxViolencePage.vue?vue&type=template&id=1d44dab7"
import script from "./ANxAVxViolencePage.vue?vue&type=script&lang=js"
export * from "./ANxAVxViolencePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports